
import react, { useState } from "react";
import { View, Text, Pressable, TextInput } from "react-native";
const ConfigError = ({...props}) => {
  let bgColor =  "#00BB86";
  let textColor = "#FFF";
  const [url, setUrl] = useState("");

return(
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      {
        <View style={[{flex: 1, width: "100%", justifyContent: "center", alignItems: "center"}]}>
            <Text style={{textAlign: "center", width: "70%", fontSize: 16}}>{props.route.params.message ? props.route.params.message : "No configuration file was presented to the previewer, please make sure domain is present."}</Text>
            <Text style={{textAlign: "center", width: "70%", fontSize: 16, marginTop: 10}}>{"You can retry by entering your domain below:"}</Text>
            <TextInput style={{borderColor: "#00BB86", borderWidth: 1, height: 35, marginTop: 20, width: 200, paddingHorizontal: 10}} placeholder={"Enter domain here"} onChangeText={setUrl} value={url} />
            <Pressable onPress={() => {
                props.route.params.setLoaded(false);
                props.route.params.setConfig(false);
                props.route.params.onPress(url);
              }}
              style={{backgroundColor: bgColor, padding: 10, marginTop: 20, borderRadius: 100, width: 100}}
            >
              <Text style={{color: textColor, textAlign: "center"}}>Retry</Text>
            </Pressable>
        </View>
      }
    </View>
)};
export default ConfigError;